import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["type", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';

/**
 * Makes an Icon component.
 *
 * @param name
 * @param color
 */
var makeIconComponent = function makeIconComponent(name, color) {
  return function (props) {
    return /*#__PURE__*/React.createElement(require("../../../assets/icons/".concat(name, ".i.svg")).default, _objectSpread(_objectSpread({}, props), {}, {
      color: color
    }));
  };
};
var unknown = makeIconComponent('legend-builder-breaker', '#000');
var icons = {
  BOOL: makeIconComponent('legend-builder-yes-no', '#007be7'),
  TEXT: makeIconComponent('legend-builder-text', '#5ab3ff'),
  NUMERIC: makeIconComponent('legend-builder-numeric', '#5ab3ff'),
  DATE_TIME: makeIconComponent('legend-builder-datetime', '#e91e63'),
  DOCUMENTS: makeIconComponent('legend-builder-document-upload', '#0967b9'),
  SELECT: makeIconComponent('legend-builder-choice', '#40a0f4'),
  BREAKER: makeIconComponent('legend-builder-breaker', '#645efe')
};

/**
 * Question icon.
 */
export default function QuestionIcon(_ref) {
  var type = _ref.type,
    size = _ref.size,
    rest = _objectWithoutProperties(_ref, _excluded);
  var IconComponent = icons[type] || unknown;
  return /*#__PURE__*/React.createElement(IconComponent, _extends({
    style: size ? {
      fontSize: size
    } : undefined
  }, rest));
}
//# sourceMappingURL=index.js.map
